import React from 'react';
import './assets/css/styles.scss'
import './assets/css/main.css';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SignIn } from './pages/sign-in';
import AdminLayout from './components/adminLayout';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <Toaster />
    <BrowserRouter>
      <Routes>
        <Route path='/*' element={<AdminLayout />} />
        <Route exact path="/login" element={<SignIn />} />

      </Routes>
    </BrowserRouter>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
